import CoverVacancies from './CoverVacancies';
export default CoverVacancies;